import {
  HIGH_FREQUENCY_TRUCK_TRANS,
  HIGH_FREQUENCY_TRUCK_LEFT,
  HIGH_FREQUENCY_FIRST_CLICK,
} from "./../actions/actionIdentifiers";
import { INTRO_STAGE, PLAY_STAGE, FINISH_STAGE } from "./stateIdentifiers";
import {
  HIGH_FREQUENCY_WORD_IMPORT,
  HIGH_FREQUENCY_INIT_SPEC,
  HIGH_FREQUENCY_SELECT_TRUCK,
  HIGH_FREQUENCY_SELECT_TRUCK_TYPE,
  HIGH_FREQUENCY_SELECT_PLACE,
  HIGH_FREQUENCY_START_GAME,
  HIGH_FREQUENCY_FINISH,
  HIGH_FREQUENCY_SET_NEW_ROUND,
  HIGH_FREQUENCY_DRAG,
  HIGH_FREQUENCY_CHECK_ANSWER,
  HIGH_FREQUENCY_CANCEL_RESPONSE,
  HIGH_FREQUENCY_RESET_DISPLAY,
  HIGH_FREQUENCY_PLAY_AGAIN,
  HIGH_FREQUENCY_TRUCK_ACTIVE,
} from "../actions/actionIdentifiers";

export interface HighFrequencyWordState {
  stage: string;
  truckOptions: { truckType: number; trucks: string[] }[];
  placeOptions: number[];
  totalRound: number;
  words: string[];
  truckType: number;
  truck: string;
  place: number;
  answers: string[];
  round: number;
  display: string[];
  answer: string;
  answered: string;
  response: string;
  truckActive: boolean;
  truckTransition: boolean;
  truckLeft: string;
  firstClicked: boolean;
  fileUnit: number
}

const initialState: HighFrequencyWordState = {
  stage: INTRO_STAGE,
  // stage: PLAY_STAGE,
  // stage: FINISH_STAGE,
  truckOptions: [],
  placeOptions: [],
  totalRound: null,
  words: [],
  truckType: null,
  truck: null,
  place: null,
  answers: [],
  round: 0,
  display: [],
  answer: null,
  answered: null,
  response: null,
  truckActive: false,
  truckTransition: false,
  truckLeft: null,
  firstClicked: false,
  fileUnit: null
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HIGH_FREQUENCY_FIRST_CLICK:
      return { ...state, firstClicked: true };
    case HIGH_FREQUENCY_WORD_IMPORT:
      return { ...state, ...payload };
    case HIGH_FREQUENCY_INIT_SPEC:
      return { ...state, ...payload };
    case HIGH_FREQUENCY_SELECT_TRUCK:
      return { ...state, truck: payload.truck };
    case HIGH_FREQUENCY_SELECT_TRUCK_TYPE:
      return { ...state, ...payload };
    case HIGH_FREQUENCY_SELECT_PLACE:
      return { ...state, place: payload.place };
    case HIGH_FREQUENCY_START_GAME:
      return { ...state, stage: PLAY_STAGE };
    case HIGH_FREQUENCY_SET_NEW_ROUND:
      return { ...state, ...payload };
    case HIGH_FREQUENCY_TRUCK_ACTIVE:
      return { ...state, truckActive: payload.truckActive };
    case HIGH_FREQUENCY_TRUCK_TRANS:
      return { ...state, truckTransition: payload.truckTransition };
    case HIGH_FREQUENCY_TRUCK_LEFT:
      return { ...state, truckLeft: payload.truckLeft };
    case HIGH_FREQUENCY_DRAG:
      return { ...state, ...payload };
    case HIGH_FREQUENCY_CHECK_ANSWER:
      return { ...state, response: payload.response };
    case HIGH_FREQUENCY_CANCEL_RESPONSE:
      return { ...state, response: null };
    case HIGH_FREQUENCY_RESET_DISPLAY:
      return { ...state, ...payload };
    case HIGH_FREQUENCY_FINISH:
      return { ...state, stage: FINISH_STAGE };
    case HIGH_FREQUENCY_PLAY_AGAIN:
      return { ...initialState, firstClicked: true };
    default:
      return state;
  }
};
